import { CompFieldRatingCore } from '../core/forms/rating/comp'

export const CompFieldRating = CompFieldRatingCore
